import axios, { AxiosInstance } from "axios";

const { SERVICES_URL } = window.MLBBest.envVariables || {};

const MUTClient: AxiosInstance = axios.create({
  baseURL: SERVICES_URL,
});

export default MUTClient;
